module.exports = __webpack_public_path__ + "img/Icon-2_pointer.935dea8f.svg";